import React from 'react';
import { Notification, Card, Title } from "rbx";
import QuestionService from '../../services/question';
import Controls from '../components/Controls/Controls';
import useForm from '../components/useForm';

const styleHr = {
  backgroundColor: 'transparent', 
  borderColor: 'rgb(221, 221, 221)', 
  borderStyle: 'dashed', 
  borderWidth: '1px 0px 0px', 
  margin: '3px'
};

const QuestionsForm = (props) => {
  const { newRecord=false, question, fetchQuestions, setMessage } = props;

  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm({ 
    title: question ? question.title : '', 
    answer: question ? question.answer : '' 
  } );

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStateButton("loading");
    try {
      let response;
      if (newRecord) {
        response = await QuestionService.register(values);
      } else {
        const data = { _id: question._id, ...values };
        response = await QuestionService.edit(data);
      }
      fetchQuestions();
      setMessage(['success', `${response.status}: ${response.data.message}`]);
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setStateButton('');
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Title size={5} className="mb-4">
            {newRecord ? 'Nova ' : 'Editar '} Pergunta Frequente
          </Title>
          <hr style={ styleHr }/>
          <Controls.TextareaField 
            label="Pergunta"
            name="title"
            value={values.title}
            onChange={handleInputChange}
            placeholder='Escreva a pergunta aqui.'
            focus={true}
            required
          />
          <Controls.TextareaField 
            label="Resposta"
            name="answer"
            value={values.answer}
            onChange={handleInputChange}
            placeholder='e a resposta aqui.'
            required
          />
          <Controls.ActionButton 
            buttonState={stateButton}
            buttonName={newRecord ? 'Registrar' : 'Atualizar'}
          />
        </Card.Content>
      </Card>
    </form>
  )

}

export default QuestionsForm;

